import { useSyncExternalStore } from "use-sync-external-store/shim";

let sharingAll = false;
const listeners = new Set<() => void>();

export const sharingAllStore = {
  setSharingAll(value: boolean) {
    sharingAll = value;
    emitChange();
  },
  subscribe(listener: () => void) {
    listeners.add(listener);
    return () => listeners.delete(listener);
  },
  getSnapshot: () => sharingAll,
};

function emitChange() {
  for (const listener of listeners) {
    listener();
  }
}

export function useSharingAll() {
  return useSyncExternalStore(
    sharingAllStore.subscribe,
    sharingAllStore.getSnapshot,
  );
}
